// mutations.js

export default {
   updateTreeList(state, treeList) {
        console.log('Обновление списка дерева, элементов:', treeList.length);
        state.treeList = treeList;
   },
   
   addNode(state, node) {
        console.log('Добавляем узел в список:', node);
        // Проверяем, нет ли уже такого узла в списке
        if (!state.treeList.some(n => n.id === node.id)) {
            // Добавляем новый узел в список
            state.treeList.push(node);
            console.log('Узел добавлен, всего узлов:', state.treeList.length);
        }
   },
   
   updateNode(state, payload) {
        console.log('Обновляем узел:', payload);
        // Находим узел по id и обновляем его
        const index = state.treeList.findIndex(node => node.id === payload.id);
        if (index !== -1) {
            state.treeList[index] = { ...state.treeList[index], ...payload };
            console.log('Узел обновлен');
        }
   },
   
   removeNode(state, nodeId) {
        console.log('Удаляем узел:', nodeId);
        
        // Рекурсивная функция для получения всех идентификаторов дочерних элементов
        const getAllChildIds = (parentId) => {
            // Находим все непосредственные дочерние элементы
            const directChildren = state.treeList.filter(node => node.parent_id === parentId);
            
            // Для каждого дочернего элемента находим его дочерние элементы
            let allChildIds = directChildren.map(child => child.id);
            
            // Рекурсивно добавляем дочерние элементы дочерних элементов
            directChildren.forEach(child => {
                allChildIds = allChildIds.concat(getAllChildIds(child.id));
            });
            
            return allChildIds;
        };
        
        // Получаем все идентификаторы дочерних элементов
        const childIds = getAllChildIds(nodeId);
        console.log('Дочерние элементы для удаления:', childIds);
        
        // Создаем массив всех узлов, которые нужно удалить (узел + дочерние)
        const idsToRemove = [nodeId, ...childIds];
        
        // Фильтруем список, оставляя только узлы, которые не нужно удалять
        const initialCount = state.treeList.length;
        state.treeList = state.treeList.filter(node => !idsToRemove.includes(node.id));
        console.log(`Удалено узлов: ${initialCount - state.treeList.length}`);
   }
};
